import axios from 'axios';
import api from './api';

const baseURL = api.defaults.baseURL;

/** فقط برای مسیرهای عمومی فرم؛ توکن کارمند را نمی‌فرستد تا با توکن پرکننده تداخل نداشته باشد */
const formGuestClient = axios.create({
  baseURL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

formGuestClient.interceptors.request.use((config) => {
  const t = localStorage.getItem('formFillerToken');
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function setFormFillerToken(token) {
  if (token) localStorage.setItem('formFillerToken', token);
  else localStorage.removeItem('formFillerToken');
}

export function clearFormFillerSession() {
  localStorage.removeItem('formFillerToken');
  localStorage.removeItem('formFillerPhone');
}

export function getFormFillerToken() {
  return localStorage.getItem('formFillerToken');
}

export const listPublicForms = () => formGuestClient.get('/forms/public/list');

export const getPublicForm = (formId) => formGuestClient.get(`/forms/public/${formId}`);

export const sendFormFillOtp = (phone) =>
  formGuestClient.post('/forms/public/send-otp', { phone });

export const verifyFormFillOtp = (phone, otp) =>
  formGuestClient.post('/forms/public/verify-otp', { phone, otp });

export const getMyFormSubmission = (formId) =>
  formGuestClient.get(`/forms/public/${formId}/submission`);

export const saveFormSubmission = (formId, answers) =>
  formGuestClient.put(`/forms/public/${formId}/submission`, { answers });

// ——— پنل مدیر ———

export const listFormsAdmin = () => api.get('/forms');

export const getFormAdmin = (id) => api.get(`/forms/${id}`);

export const createFormAdmin = (body) => api.post('/forms', body);

export const updateFormAdmin = (id, body) => api.put(`/forms/${id}`, body);

export const deleteFormAdmin = (id) => api.delete(`/forms/${id}`);

export const listFormSubmissionsAdmin = (id, params) =>
  api.get(`/forms/${id}/submissions`, { params });
